import React from "react";
// import { ReactComponent as Logo } from "../../../src/assets/images/logo.png";
import Logo from "../../../src/assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import callIcon from "../../../src/assets/images/8.svg"
import mailIcon from "../../../src/assets/images/9.svg"
import addressIcon from "../../../src/assets/images/7.svg"
export const Footer = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#141d3c", width: window.innerWidth > 1000 ? "100%" : "unset",
            height: "auto", gap: 30, color: "#ffffff", fontSize: 20, fontWeight: 300, marginTop: 60
        }}>
            <div style={{ fontSize:18,width: window.innerWidth < 1000 ? "unset":"98%", display: "flex", justifyContent: window.innerWidth < 1000 ? "flex-start":"space-between", alignItems: window.innerWidth < 1000 ? "flex-start" : "center", flexDirection: window.innerWidth > 1000 ? "row" : "column" ,marginTop:30,marginLeft:window.innerWidth > 1000 ? 0:30}}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: window.innerWidth > 1000 ? 30 :10 ,flexDirection: window.innerWidth > 1000 ? "row" : "column"}}>
                    <div style={{textAlign:"left",marginLeft:30}}>
                        <div
                          style={{
                          fontSize: "20px",
                          textDecorationLine: "underline",
                          textDecorationThickness: "1px", // thinner underline
                          textUnderlineOffset: "3px",     // optional: adjust vertical space
                          }}
                         >
                         Quick links
                        </div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/")}>Home</div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/about_us")}>About Us</div>
                        {/* <div style={{ cursor: "pointer" }} onClick={() => navigate("/services")}>Services</div> */}
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/products")}>Products</div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/contact_us")}>
                            Contact us
                        </div>
                    </div>
                  
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: window.innerWidth>1000 ? "40%":"80%", textAlign: "left",marginTop:window.innerWidth < 1000 ? 20:0 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center",gap:10 }}>
                        <div><img style={{ width: 20, height: 20 }} src={callIcon}></img></div>
                          <div>+91-9445979137</div>
                        
                    </div>
                   <div style={{ display: "flex", alignItems: "center", justifyContent: "center",gap:10 }}>
                        
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        <div><img style={{ width: 20, height: 20 }} src={mailIcon}></img></div>
                        <div>ram@geesendeavour.com</div>
                    </div>
                    <div style={{ display: "flex",  justifyContent: "center", gap: 10 }}>
                        <div style={{marginTop:3}}><img style={{ width: 20, height: 20 }} src={addressIcon}></img></div>
                        <div>#79-3F, Pillyar Koil Street, Puliyambeadu, Vellapanchavadi
Chennai, Tamilnadu, India-600077</div>
                    </div>
                </div>
            </div>
            <div style={{ marginTop: 10, borderTop: "1px solid white", width: "100%", padding: 10,fontSize:14 }}>
                Developed by <a href="https://digital.honesti.in" style={{ color: "#fff" }}>@ Honesti Digital</a>
            </div>
        </div>
    )
}